<template>
    <UIModal class="wallet-imex-frame" padding="182" @close="onClose">
        <div class="wallet-imex-frame__content">
            <h2 class="wallet-imex-frame__title">{{ $t('wallet.imexFrameTitle') }}</h2>

            <p class="wallet-imex-frame__description">{{ $t('wallet.imexFrameDescription') }}</p>

            <div class="wallet-imex-frame__actions">
                <UIButton
                    :label="$t('wallet.imexFrameOpen')"
                    view="main"
                    :full="true"
                    :disabled="!getFrameUrl"
                    @clicked="onOpenFrame"
                />

                <UIButton
                    v-if="!cancelConfirm"
                    :label="$t('wallet.imexCancelWithdrawal')"
                    view="secondary"
                    :full="true"
                    :disabled="loading"
                    @clicked="cancelConfirm = true"
                />

                <div v-if="cancelConfirm" class="wallet-imex-frame__cancel-confirm">
                    <p>{{ $t('wallet.imexCancelConfirm') }}</p>
                    <UIButton
                        :label="$t('wallet.imexCancelWithdrawal')"
                        view="secondary"
                        :full="true"
                        :disabled="loading"
                        @clicked="onCancel"
                    />
                </div>
            </div>
        </div>
    </UIModal>
</template>

<script>
import UIModal from "@/components/ui/modal/modal.vue";
import UIButton from "@/components/ui/button/button.vue";

import {COMPONENTS} from "@/components/shared/wallet/content/content.vue";

import Api from "@/api/api.js";

const api = new Api();

export default {
    name: "WalletImexFrame",
    components: {
        UIModal,
        UIButton
    },
    props: {
        confirm: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            loading: false,
            cancelConfirm: false
        };
    },
    computed: {
        getFrameUrl() {
            return this.confirm && this.confirm.imexFrameUrl;
        }
    },
    methods: {
        onOpenFrame() {
            if (this.getFrameUrl) {
                window.open(this.getFrameUrl, "_blank", "noopener,noreferrer");
            }
        },

        async onCancel() {
            this.loading = true;
            try {
                await api.withdrawCancel(this.confirm.id);
                this.$emit("refresh");
                this.onClose();
            } catch (_) {
                // error shown by global handler
            } finally {
                this.loading = false;
            }
        },

        onClose() {
            this.$emit("close", COMPONENTS.default);
        }
    }
};
</script>

<style lang="scss">
.wallet-imex-frame {
    .wallet-imex-frame__content {
        width: 640px;
        padding: 48px 100px 57px;
        display: flex;
        flex-direction: column;
        align-items: center;
        grid-row-gap: 24px;
    }

    .wallet-imex-frame__title {
        font-size: 28px;
        line-height: 34px;
        text-align: center;
        color: $txt-main;
    }

    .wallet-imex-frame__description {
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        color: $txt-main;
    }

    .wallet-imex-frame__actions {
        display: flex;
        flex-direction: column;
        grid-row-gap: 12px;
        width: 100%;
    }

    .wallet-imex-frame__cancel-confirm {
        display: flex;
        flex-direction: column;
        align-items: center;
        grid-row-gap: 8px;

        p {
            font-size: 13px;
            color: $txt-main;
            text-align: center;
        }
    }
}

@media screen and (max-width: 768px) {
    .wallet-imex-frame {
        .wallet-imex-frame__content {
            width: 100%;
            padding: 32px 0 24px 0;
        }

        .wallet-imex-frame__title {
            font-size: 24px;
            line-height: 29px;
        }
    }
}
</style>
